import React, { useState } from 'react';
import styles from './AdminMobileSearchInput.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import search from 'routes/adminMobile/images/search.png';
import { compBgColor, compBorderRadius, compCommonPadd } from 'routes/adminMobile/constraints/AdminConst';

const AdminMobileSearchInput = ({ placeholder, onSearch }) => {
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (event) => {
        setInputValue(event.target.value); // 입력값 업데이트
    };

    const handleSearch = () => {
        onSearch(inputValue); // 검색 버튼 클릭 시 부모 컴포넌트에 입력값 전달
    };

    return (
        <HorizontalFlex
            padding={compCommonPadd}
            backgroundColor={compBgColor}
            borderRadius={compBorderRadius}
        >
            <FlexChild>
                <input className={styles.input} type='text' placeholder={placeholder} value={inputValue} onChange={handleInputChange}  />
            </FlexChild>
            <FlexChild width="auto">
                <img className={styles.search} src={search} alt='검색 버튼' onClick={handleSearch} />
            </FlexChild>
        </HorizontalFlex>
    );
};

export default AdminMobileSearchInput;